<template>
  <div v-show="breads.length > 0" class="scmcc-breadcrumbs">
    <div class="scmcc-breadcrumbs-content">
      <div
        v-for="(item, i) of breads"
        v-show = "item.meta&&!item.meta.noBread"
        :key="item.name"
        class="scmcc-breadcrumbs-item"
      >
        <span
          @click="go(i, item.name,item.query, item.path)"
          class="scmcc-breadcrumbs-text"
          :class="{ active: i === breads.length - 1 }"
          >{{ item.meta.title }}</span
        >
        <span
          v-if="i !== breads.length - 1"
          v-show = "item.meta&&!item.meta.noBread"
          class="scmcc-breadcrumbs-separator"
          >{{ separator }}</span
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'breadcrumbs',
  data: () => ({
    breads: [],
    separator: '/'
  }),
  watch: {
    $route: {
      handler(n) {
        console.log('bread---',n)
        if (n.matched.length < 3) return (this.breads = [])
        this.changeBreads(n)
        this.breads = n.matched
      },
      immediate: true
    }
  },
  mounted(){
    this.$eventBus.on('_callBreadcrumbs',data => {
      // console.log(data);
      if(data&&data.length){
        setTimeout(() => {
         this.breads = [];
         for(let i = 0;i<data.length;i++){
            if(data[i].meta&&data[i].meta.title){
              this.breads.push({
                meta: data[i].meta,
                title: data[i].meta.title,
                // name: data[i].name,
                path: data[i].path,
                query: {...data[i].query}
              })
            }
        }
       })
       
      }
    })
  },
  methods: {
    changeBreads(route) {
      console.log(route)
      route.matched.forEach(item => {
        console.log('bread---',item)
        this.breads.push({
          title: item.meta.title,
          name: item.name
        })
      })
      // let targetIndex = this.breads.findIndex(item => route.name === item.name)
      // if (targetIndex > -1) {
      //   this.breads.splice(targetIndex + 1)
      //   this.breads[this.breads.length - 1].active = true
      // } else {
      //   this.breads.forEach(item => {
      //     item.active = false
      //   })
      //   this.breads.push({
      //     title: route.meta.title,
      //     name: route.name,
      //     active: true
      //   })
      // }
    },
    go(n,name,query,path){
      if(n>=0){
        if(name){
          query?this.$router.push({ name:name ,query}):this.$router.push({ name:name })
        }else{
          query?this.$router.push({ path:path ,query}):this.$router.push({ path:path })
        }
        // if(query){
        //   this.$router.push({ name:name ,query})
        // }else{
        //   this.$router.push({ name:name })
        // }
      } 
    }
  }
}
</script>
<style lang="stylus">
.scmcc-breadcrumbs
  margin-bottom 17px
  font-size 12px

  .scmcc-breadcrumbs-content
    display flex

    .scmcc-breadcrumbs-text
      cursor pointer

      &.active
        color #515A6E

      &:hover
        color #366BBB

    .scmcc-breadcrumbs-separator
      font-size 12px
      margin 0 7px
</style>
